module.exports = __webpack_public_path__ + "img/krbsicon.c4a1ad8e.png";